import { AxiosError } from 'axios';

import { HTTP_STATUS } from '@/api/ErrorCode.model.ts';

export type BootstrapErrorView = 'noSession' | 'notAuthorized' | 'serviceUnavailable';

const SERVICE_UNAVAILABLE_ERROR_CODES = ['ECONNABORTED', 'ERR_NETWORK'];
const SERVICE_UNAVAILABLE_STATUSES = [HTTP_STATUS.BAD_GATEWAY, HTTP_STATUS.GATEWAY_TIMEOUT];

export const getBootstrapErrorView = (
  error?: Pick<AxiosError, 'code' | 'status'> | null,
): BootstrapErrorView => {
  if (SERVICE_UNAVAILABLE_ERROR_CODES.includes(error?.code ?? '')) {
    return 'serviceUnavailable';
  }

  if (SERVICE_UNAVAILABLE_STATUSES.includes(error?.status ?? 0)) {
    return 'serviceUnavailable';
  }

  if (error?.status === HTTP_STATUS.UNAUTHORIZED) {
    return 'notAuthorized';
  }

  return 'noSession';
};
